import { Button, Tag } from "antd";

const InvalidSubsColumns = ({ goToClientDetails }) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: true,
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "İsim",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "İptal Nedeni",
    dataIndex: "invalidSubscriptionReason",
    key: "invalidSubscriptionReason",
    render: (value) => (
      <div style={{ display: "flex" }}>{value.description}</div>
    ),
  },
  {
    title: "Telefon Numarası",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
  },
  {
    title: "E-posta",
    dataIndex: "email",
    key: "email",
  },

  {
    title: "Telefon Doğrulandı",
    dataIndex: "isPhoneNumberAdded",
    key: "isPhoneNumberAdded",
    render: (value) => (
      <div style={{ display: "flex" }}>
        {value ? <Tag color="green">Evet</Tag> : <Tag color="red">Hayır</Tag>}
      </div>
    ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex" }}>
        <Button type="link" onClick={() => goToClientDetails(record.id)}>
          Detaylar
        </Button>
      </div>
    ),
  },
];

export { InvalidSubsColumns };
